import { PhotoGroupList } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';

export const getPhotoGroupIdFromPhotoId = (
  photoId: string,
  imageRelations: PhotoGroupList[]
): string => {
  console.log(imageRelations);
  return imageRelations.reduce((previousValue, currentValue) => {
    const index = currentValue.photos.findIndex(
      (photo) => photo.photoId === photoId
    );
    if (index !== -1) {
      return currentValue.photos[index].photoGroupId;
    }
    return previousValue;
  }, null as string);
};

export const getPhotoGroupFromPhotoId = (
  photoId: string,
  imageRelations: PhotoGroupList[]
): {
  height: number;
  width: number;
  photoGroupHasPhotoId: string;
  photoId: string;
  photoGroupId: string;
} => {
  return imageRelations.reduce(
    (previousValue, currentValue) => {
      const index = currentValue.photos.findIndex(
        (photo) => photo.photoId === photoId
      );
      if (index !== -1) {
        return currentValue.photos[index];
      }
      return previousValue;
    },
    null as {
      height: number;
      width: number;
      photoGroupHasPhotoId: string;
      photoId: string;
      photoGroupId: string;
    }
  );
};
